<template>
  <div class="pa-0 ma-0" style="min-height: 100vh !important">
    <v-carousel
      class="pa-0 ma-0"
      cycle
      continuous
      progress
      :show-arrows="false"
      :interval="interval"
      height="100vh"
    >
      <!-- <hbt-navbar :endtime="endtime" /> -->
      <v-carousel-item v-for="(c,i) in capas" :key="i" class="pa-0 ma-0" style="height: 100vh">
        <v-parallax 
          dark
          class="px-0 mx-0"
          v-bind="heightParallax"
          style="height: 100% !important;"
          :src="getImgUrl(c.parallax)"
        >
          <div style="
            background-image: linear-gradient(to right, rgba(42, 55, 121, 0.65), rgba(255, 255, 255, 0.35));
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
          "></div>
          <v-container style="position: relative; height: 100%; top: 100px">
            <v-row 
              class="align-center justify-center" 
            >
              <v-col cols="11" md="10"
                class="px-0 text-center pt-12"
              >
                <div class="font-weight-medium white--text text--darken-2"
                  :class="{
                    'subtitle-1': $vuetify.breakpoint.mdAndUp,
                    'body-1': $vuetify.breakpoint.smAndDown,
                  }"
                >
                  <span class=""><v-icon color="primary">mdi-map-marker</v-icon> EM FORTALEZA</span>
                </div>
                <h1 
                  class="white--text font-weight-medium pt-3"
                  :class="{
                    'display-4': $vuetify.breakpoint.mdAndUp,
                    'display-3': $vuetify.breakpoint.smAndDown,
                  }"
                  style="line-height: 0.9"
                >
                  <span class="poppins">viva</span> <br v-if="$vuetify.breakpoint.smAndDown"> <span class="poppins black--text">sua</span><br>
                  <span class="poppins">melhor</span> <span class="poppins black--text">versão</span><br>
                </h1>
                <div class="font-weight-regular white--text pt-4 px-4"
                  :class="{
                    'headline': $vuetify.breakpoint.mdAndUp,
                    'title': $vuetify.breakpoint.smAndDown,
                  }"
                >
                  <!-- <span class="lato" v-html="c.subtitulo">Oferecemos treinamento para melhorar o desempenho e garantia de integridade na gestão dos recursos públicos.</span> -->
                  <span class="open-sans">O maior poder que o ser humano pode ter é o de ser ele de verdade</span>
                </div>
                <div class="mt-4">
                  <v-btn
                    x-large outlined
                    color="white"
                    class="mt-5"
                    :class="{
                      '': $vuetify.breakpoint.mdAndUp,
                    }"
                    :href="c.link"
                    target="_blank"
                    @click="$vuetify.goTo('#frases')"
                  >
                    <span class="font-weight-bold">Saber mais</span>
                  </v-btn>
                  <v-btn
                    x-large
                    color="white primary--text"
                    class="mt-5"
                    :class="{
                      'ml-3': $vuetify.breakpoint.mdAndUp,
                    }"
                    :href="c.link"
                    target="_blank"
                    @click="$vuetify.goTo('#mais-info')"
                  >
                    <span class="font-weight-bold">Quero Participar</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<style >
/* .heightParallax{
  height: 100%
} */
</style>

<script>
// import HbtNavbar from '../components/Navbar';

export default {
  components: {
    // HbtNavbar,
  },
  data: () => ({
    logo: 'logo.png',
    paral: 'height',
    capas: [
      {
        parallax: 'capa.jpg',
        // titulo: 'Pela Eficiência na <span class="primary--text">Gestão e Uso dos Recursos Públicos</span>',
        subtitulo: 'O maior poder que o ser humano pode ter é o de ser ele de verdade',
        // botao: 'Experimente 1 semana grátis',
        link: '',
        click: '#mais-info'
      },
      // {
      //   parallax: require('../assets/capa3-min.jpg'),
      //   titulo: '<span class="title font-weight-bold grey--text text--darken-2">Curso Avançado de</span><br><span class="primary--text">Contabilidade para Serviços Sociais Autônomos</span>',
      //   subtitulo: '<b class="font-weight-bold">21 e 22/nov</b>, em Brasília-DF',
      //   botao: 'Fazer Inscrição',
      //   link: 'https://eventos.rm2compliance.com.br/curso-de-contabilidade-publica'
      // },
      // {
      //   parallax: require('../assets/capa4-min.jpg'),
      //   titulo: '<span class="title font-weight-bold grey--text text--darken-2">Curso Avançado de</span><br><span class="primary--text">Prestação de Contas Anuais e Relato Integrado</span>',
      //   subtitulo: '<b class="font-weight-bold">28 e 29/nov</b>, em Brasília-DF',
      //   botao: 'Fazer Inscrição',
      //   link: 'https://eventos.rm2compliance.com.br/curso-de-prestacao-de-contas'
      // },
    ],
    interval: 6000,
  }),
  computed: {
    heightParallax () {
      if (this.$vuetify.breakpoint.smAndDown) {
        return { height: '100%' }
      }
      else{
        return null
      }
    }
  },
  methods: {
    getImgUrl(i) {
      return require('../assets/img/'+i)
    },
  }
};
</script>
